import { useEffect } from 'react'
import { Box } from '@mui/material'
import { Button, RouteLayout } from 'components'
import { useAuthContext } from 'contexts'
import { isUserPatient, registerPageAccess } from 'helpers'
import PatientText from './patient-text'
import InformantText from './informant-text'
import { sxButton } from './start-questionnaire-styles'

function StartQuestionnaire({ type, handleGoNext, patientInfo }: any) {
  const { user } = useAuthContext()
  useEffect(() => {
    registerPageAccess('Questionário', {
      user_id: user.userId,
      patient_id: patientInfo.patientId,
      source: isUserPatient(user) ? 'patient' : 'caregiver',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <RouteLayout bg='gradient'>
      <Box
        m={5}
        flexGrow={1}
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        alignItems='center'
      >
        <Box />
        <Box>
          {type === 'patient' ? (
            <PatientText patientInfo={patientInfo} />
          ) : (
            <InformantText patientInfo={patientInfo} />
          )}
        </Box>
        <Box width={223}>
          <Button color='white' onClick={handleGoNext} sx={sxButton}>
            Começar
          </Button>
        </Box>
      </Box>
    </RouteLayout>
  )
}

export default StartQuestionnaire
